import { updateCategory } from '@wordpress/blocks';
import { ReactComponent as BlockplayerIcon } from './assets/icons/blockplayer-category.svg';
import './blocks/the-player/index';
if ( updateCategory ) {
    updateCategory( 'blockplayer', {
        icon: <BlockplayerIcon/>,
    } );
}
